export default "__VITE_ASSET__CP2EWHTR__"